import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/type-invitation';

class InvitationTypeService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default InvitationTypeService;



// WEBPACK FOOTER //
// ./src/services/InvitationTypeService.js